export default function NotFound() {
    return (
        <div className="not-found">
            <span>Seite nicht gefunden</span>
        </div>
    )
}